import { getFunctions, httpsCallable } from "firebase/functions";

const functions = getFunctions(undefined, "us-central1");
const _enviar   = httpsCallable(functions, "enviarEmail");

const call = (data) => _enviar(data).catch(e => console.warn("[Email]", e.message));

export const emailBoasVindas          = (nome, email)              => call({ tipo:"boasVindas",              nome, email });
export const emailRedefinicaoSenha    = (email)                    => call({ tipo:"redefinicaoSenha",        nome:email, email });
export const emailAssinatura          = (nome, email, plano)       => call({ tipo:"assinatura",              nome, email, plano });
export const emailExpiracaoProxima    = (nome, email, diasRestantes) => call({ tipo:"expiracaoProxima",      nome, email, diasRestantes });
export const emailBoasVindasClienteFinal = (nome, email, loja) => call({ tipo:"boasVindas_cliente_final", nome, email, loja });
export const emailPedidoConcluido        = (nome, email, loja, produto) => call({ tipo:"pedido_concluido", nome, email, loja, produto });
